export default __webpack_public_path__ + "static/media/place-map.de6253cb.svg";